<template>
  <div id="msg">
    <div class="header">
      <h2>共有: {{data.length}} 条问题</h2>
      <div>
        <el-button @click="exportTable" type="success">导出</el-button>
      </div>
    </div>
    <el-table class="table" :data="data" style="width: 80%" border stripe id="out-table">
      <el-table-column prop="content" label="问题"></el-table-column>
    </el-table>
  </div>
</template>
    <script>
import FileSaver from "file-saver";
import XLSX from "xlsx";
export default {
  data() {
    return {
      data: []
    };
  },
  mounted() {
    let k = this.$route.query;
    console.log("+++", k);
    this.getProject(k.mid);
  },
  methods: {
    getProject(mid) {
      this.$api.getProjectFile({ mid: mid }).then(res => {
        this.data = res.result.data;
      });
    },
    search() {},
    exportTable() {
      var wb = XLSX.utils.table_to_book(document.querySelector("#out-table"));
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array"
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          "问题汇总.xlsx"
        );
      } catch (e) {
        console.log("e", e);
      }
      return wbout;
    }
  }
};
</script>
<style lang="scss">
#msg {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 80%;
  }
  .table {
  }
}
</style>
